import { Editor, Range, Transforms, Text } from 'slate'

export const addMarksData = (editor, data) => {
    const { format, value } = data;
    const { selection } = editor;
    
    if(!selection) {
        return;
    }

    Transforms.setNodes(
        editor,
        { [format]: value },
        { match: n => Text.isText(n), split: true }
    );
    Editor.addMark(editor, format, value);
}

export const removeMarksData = (editor, data) => {
    const { format } = data;

    if (!editor.selection) {
        return;
    }

    Editor.removeMark(editor, format);
}

export const isMarkActive = (editor, format) => {
    const marks = Editor.marks(editor)    
    return marks ? marks[format] === true : false
}

// In SlateFunction.js
export const insertLink = (editor, { url, text }) => {
    const { selection } = editor;
    if (!selection) return;

    const link = {
        type: 'link',
        url,
        children: [{ text }],
    };

    if (Range.isCollapsed(selection)) {
        //  Insert the link
        Transforms.insertNodes(editor, link);
        // Insert a trailing text node
        Transforms.insertNodes(editor, { text: ''});

        // Move selection to trailing text node
        const point = Editor.after(editor, editor.selection.anchor.path);
        if (point) {
            Transforms.select(editor, point);
            Transforms.insertNodes(editor, { text: '. ' });
        }
    } else {
        // Wrap selected text
        Transforms.wrapNodes(editor, link, { split: true });
        
        // Move cursor after the link
        const point = Editor.after(editor, editor.selection.focus.path);
        if (point) {
            Transforms.select(editor, point);
            Transforms.insertNodes(editor, { text: ' ' });
        }
    }
};

